export default "__VITE_ASSET__DmFyzTmc__"